import { Profile } from '@foxcorp/foxkit-profile-js';
import Cookies from 'universal-cookie';

const getDelayPromise = (duration) =>
  new Promise((resolve) => {
    setTimeout(resolve, duration);
  });

// Copied from foxcorp-product/fox-webapp/packages/shared/utils/profileSDK/index.ts
export class ExtendedProfileSDK extends Profile {
  isXidRequesting;
  deviceIdCookieName;

  constructor(profileSDKConfig, deviceIdCookieName) {
    super(profileSDKConfig);

    this.deviceIdCookieName = deviceIdCookieName;
    this.isXidRequesting = false;
  }

  async getUserXid() {
    const cookies = new Cookies();
    const existingXid = cookies.get(this.deviceIdCookieName);

    // If we're already requesting the xid, wait for it to set the xid cookie, this avoids multiple xid requests.
    if (this.isXidRequesting) {
      await getDelayPromise(200);

      const updatedXidCookie = cookies.get(this.deviceIdCookieName);

      if (updatedXidCookie) {
        this.isXidRequesting = false;

        return updatedXidCookie;
      }

      return this.getUserXid();
    }

    if (existingXid) {
      return existingXid;
    }

    this.isXidRequesting = true;

    const result = await this.getXid({});

    if (result.error) {
      throw new Error('Could not fetch xid');
    }

    const { xid } = result;

    if (xid) {
      cookies.set(this.deviceIdCookieName, xid);

      return xid;
    }

    throw new Error('Xid not found in response');
  }
}
